<template>
  <div>
    <el-row class="row-box" :gutter="10" type="flex" v-loading="moduleListLoading">
      <el-col v-for="(item,index) in moduleList" :key="index" :span="item.width" :xs="item.width > 12 ? item.width : 12" :sm="item.width > 8 ? item.width : 8" :md="item.width > 6 ? item.width : 6" :xl="item.width">
        <el-card class="card-box">
          <!-- 表头 -->
          <div slot="header" class="card-header">
            <!-- 标题 -->
            <div class="title-box">
              <h5 v-if="item.listData.title" v-html="item.listData.title" />

              <template v-else>
                <h5 class="title">{{ item.name }} </h5>
                <h5 v-if="source == 'menu' && item.userName" class="title">（由 {{ item.userName }} 分享）</h5>
              </template>
              <h5 v-if="developer" class="title"> {{ item.code }} </h5>
            </div>

            <!-- 右侧操作按钮 -->
            <div v-if="source !== 'download'" class="tip-butn">

              <!-- 编辑 我的看板 tabs -->
              <i v-if="isAdmin && source == 'menu'" class="el-icon-edit-outline" @click="handleAddTabs(item)" />

              <!-- 收缩 -->
              <template>
                <i :class="item.isModelShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" @click="item.isModelShow = !item.isModelShow" />
              </template>

              <!-- 提示？ -->
              <el-popover placement="bottom" width="400" trigger="hover">
                <div class="tip-content">
                  <span class="title">数据指标说明</span>
                  <div style="max-height:45vh;overflow-y: auto;padding-right:10px" v-html="item.popovertext" ></div>
                </div>
                <i slot="reference" class="el-icon-question" />
              </el-popover>
              <!-- 设置 -->
              <i v-if="isAdmin" class="el-icon-s-tools" @click="handleSet(item)" />
            </div>
          </div>

          <!-- 内容 -->
          <module-menu-item v-show="item.isModelShow" v-if="source == 'menu'" :key="index" :source-item="item" :filter-data="filterData" @tabClick="handleTabClick" @filterItem="handleFilter" />

          <module-card-item v-show="item.isModelShow" v-else :source="source" :source-item="item" :filter-data="filterData" @tabClick="handleTabClick" @filterItem="handleFilter" @handleResh="handleResh"
            @pageClick="handlePage" />

        </el-card>
      </el-col>
    </el-row>

    <!-- 设置版本显示内容 -->
    <set-panel ref="setPanel" @recoverList="getModule(filterData)" />
  </div>
</template>

<script>
import { ajax_modellist, ajax_model4 } from '@Bdc~/api/ajax_model'

import Bus from '@Sys~/utils/bus.js'
import ModuleCardItem from './moduleCardItem'
import SetPanel from '../setPanel.vue'
import ModuleMenuItem from './moduleMenuItem.vue'
export default {
  components: { ModuleCardItem, SetPanel, ModuleMenuItem },
  props: {
    source: {
      type: String,
      default: 'database'
    }
  },
  data() {
    return {
      isAdmin: this.$store.getters.roles.indexOf('admin') > -1 || (this.$store.getters.roles.indexOf('vip') > -1 && process.env.VUE_APP_TITLE != 'production'),
      developer: this.$store.getters.roles.indexOf('developer') > -1,
      moduleList: [],
      filterData: {}, // 模块查询参数
      pageNo: 1,
      pageSize: 10,
      isPage: 0,
      moduleListLoading: false,
    }
  },
  methods: {
    // 获取模块接口
    getModule(filterData) {
      Bus.$emit('getModule')
      this.$nextTick(() => {
        this.filterData = filterData || {}
      })
      this.moduleListLoading = true
      // console.log('模块查询：', this.filterData)
      ajax_modellist().then(response => {
        if (response.code == 1) {
          this.moduleList = response.data.map(v => {
            this.$set(v, 'isModelShow', true)
            if (v.extra.download) {
              this.$set(v.extra, 'downloadLoading', false)
            }

            this.isPage = v.extra.isPage

            // 点共享看板 时间
            if (this.source == 'menu' && v.labelList && v.labelList.length > 0) {
              v.labelList.forEach(m => {
                if (m.name == 'queryTime') {
                  m.initValues[0].value = this.filterData.header_query_time
                }
              })
            }

            return v
          })

          // console.log('===',this.moduleList)

          this.recGetList(this.moduleList, filterData)
          // 我的看板 共享看板
          if (this.source == 'menu' && this.moduleList && this.moduleList.length > 0) {
            this.$emit('handleModel', true)
          }

          // console.log('模块====：', this.moduleList)
        }

        this.moduleListLoading = false
      })
    },

    // 配置参数调用接口
    getListData(item, filterData, filterSondata) {
      // console.log('查询===',item)
      const filter_son_data = filterSondata ? JSON.parse(JSON.stringify(filterSondata)) : '' // 子条件
      const headerObj = {
        'header_view_code': item.code || '',
        'header_time_type': item.timeType || '',
        'header_property_id': item.header_property_id || null
      }

      for (var key in filterData) {
        if (filterData.hasOwnProperty(key) === true) {
          headerObj[key] = filterData[key]
        }
      }

      if (filterSondata && filterSondata.query_time && filterSondata.query_time.length > 10) {
        headerObj.header_query_time = filterSondata ? filterSondata.query_time : filterData.header_query_time
      }

      // console.log('1111======',filter_son_data, item.code)
      this.getList(item, headerObj, filter_son_data)
    },

    // 获取各个模块数据
    getList(item, headerObj, sonData) {
      const filter_son_data = sonData || ''
      // console.log('2222=====', filter_son_data)

      // 每项添加数据存储
      if (this.source == 'menu') {
        item.listData = { echartsData: {}, tableData: {}, listLoading: true }
      } else {
        if (item.kpiType == 10 || item.kpiType == 11) { // 表格
          item.listData = { thead: [], tbody: [], listLoading: true }
        } else {
          item.listData = {}
        }
      }

      if (this.isPage == 1) {
        var filter_son_datas = Object.assign({}, filter_son_data, { pageNo: this.pageNo, pageSize: this.pageSize })
      } else {
        var filter_son_datas = filter_son_data
      }

      ajax_model4(headerObj, filter_son_datas).then(response => {
        if (response.code == 1) {
          if (this.source == 'menu') {
            item.listData = response.data
            item.listData.listLoading = false
            // console.log('内容：', item)
          } else {
            if (item.kpiType == 10 || item.kpiType == 11) { // 表格
              item.listData = response.data.data
              item.listData.title = response.data.title
              item.listData.totalPage = response.data.total
              item.listData.pageNo = this.pageNo
              item.listData.pageSize = this.pageSize
              item.listData.listLoading = false
            } else {
              item.listData = response.data
            }
          }
        } else {
          item.listData.listLoading = false
        }
      })
    },

    // 递归循环调接口
    recGetList(list, filterData) {
      // console.log('list', list)
      list.forEach(item => {
        // 每项添加数据存储
        if (this.source == 'menu') {
          this.$set(item, 'listData', { echartsData: {}, tableData: {}, listLoading: true })
        } else {
          if (item.kpiType == 10 || item.kpiType == 11) { // 表格
            this.$set(item, 'listData', { thead: [], tbody: [], listLoading: true })
          } else {
            this.$set(item, 'listData', {})
          }
        }

        // tab 默认显示第一
        if (item.kpiType == -2) {
          this.$set(item, 'activeTab', item.childs[0].code)
        }

        // 递归
        if (item.kpiType == '-1' || item.kpiType == '-2') {
          if (item.childs && item.childs.length > 0) {
            if (item.kpiType == '-2') {
              item.childs = item.childs.map(v => {
                this.$set(v, 'p_kpiType', item.kpiType)
                this.$set(v, 'p_activeTab', item.activeTab)
                v.labelList = item.labelList
                return v
              })
            }

            item.childs.forEach(v => {
              if (!v.name) {
                v.name = item.name
              }
            })

            this.recGetList(item.childs, filterData)
          }
        } else {
          // 调用数据接口
          if (item.p_kpiType == '-2') {
            // console.log('特殊：', item)
            if (item.code == item.p_activeTab) {
              if (!(item.labelList && item.labelList.length > 0)) {
                this.getListData(item, filterData)
              }
            }
          } else {
            if (!(item.labelList && item.labelList.length > 0)) {
              // console.log(item)
              this.getListData(item, filterData)
            }
          }
        }
      })
    },

    // 子模块查询
    handleFilter(item, filterSondata) {
      this.pageNo = 1
      // console.log('子', item , JSON.stringify(filterSondata))
      this.getListData(item, this.filterData, filterSondata)
    },

    // tab 切换 查询
    handleTabClick(item, filterSondata) {
      // alert('接收tab' + item.code)
      this.getListData(item, this.filterData, filterSondata)
    },

    handlePage(item, filterSondata) {
      // console.log('接收handlePage' + item.code,filterSondata)
      this.pageNo = filterSondata.pageNo
      this.pageSize = filterSondata.pageSize

      this.getListData(item, this.filterData, filterSondata)
    },

    // 设置
    handleSet(item) {
      this.$refs['setPanel'].init(item)
    },

    // 我的看板 增加tabs模块
    handleAddTabs(item) {
      this.$emit('addTabs', item)
    },

    // 刷新
    handleResh(item, filterSondata) {
      console.log('比较顶级的 刷新', item)
      this.getListData(item, this.filterData, filterSondata)
    }

  }
}
</script>

<style lang="scss" scoped>
.card-box {
  margin-bottom: 20px;
  ::v-deep.el-card__header {
    padding: 3px 15px;
  }
  ::v-deep .el-card__body {
    padding: 0px 15px 15px;
  }
  .card-header {
    width: 100%;
    height: 30px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    .title-box {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      flex-grow: 1;
      width: 100px;
    }
    .title {
      margin: 0 2px 0 0;
    }
    .tip-butn {
      flex-grow: 0;
      display: flex;
      flex-flow: row nowrap;
      i {
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
}
.row-box {
  flex-flow: row wrap;
  min-height: 80vh;
}

.tip-content {
  font-size: 12px;
  color: #999;
  .title {
    font-size: 14px;
    color: #666;
    display: block;
    border-bottom: 1px solid #dedede;
    padding-bottom: 10px;
  }
}
</style>
